import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, mergeProps as _mergeProps, vShow as _vShow, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "login-wrapper"
};
const _hoisted_2 = { class: "animate login-form clearfix" };
const _hoisted_3 = { class: "form-container clearfix" };
const _hoisted_4 = { class: "form-header dark clearfix" };
const _hoisted_5 = { class: "float-start" };
const _hoisted_6 = { class: "content-title" };
const _hoisted_7 = { class: "hidden-sm" };
const _hoisted_8 = { class: "visible-sm" };
const _hoisted_9 = { class: "form-body clearfix bg-white" };
const _hoisted_10 = {
    key: 0,
    class: "col-xs-12 text-center py-4"
};
const _hoisted_11 = {
    key: 1,
    class: "col-xs-12 col-sm-12 top20 w-100"
};
const _hoisted_12 = { class: "mb-4" };
const _hoisted_13 = ["value"];
const _hoisted_14 = {
    key: 2,
    class: "col-xs-12 col-sm-12 top20 w-100"
};
const _hoisted_15 = { class: "text-center mb-4" };
const _hoisted_16 = { class: "mb-3" };
const _hoisted_17 = {
    key: 3,
    class: "col-xs-12 col-sm-12 top10 w-100"
};
const _hoisted_18 = { class: "invalid-feedback" };
const _hoisted_19 = {
    key: 4,
    class: "col-xs-12 col-sm-12 top20 w-100"
};
const _hoisted_20 = { class: "invalid-feedback" };
const _hoisted_21 = { class: "float-end top10" };
const _hoisted_22 = {
    key: 5,
    class: "col-xs-12 top10 float-end"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("form", null, [
        (!_ctx.loginState.isLoggedIn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fa-stack fa-lg fa-2x white-text" }, [
                                    _createElementVNode("i", { class: "fa fa-circle fa-stack-2x" }),
                                    _createTextVNode(),
                                    _createElementVNode("i", { class: "fa fa-unlock-alt fa-stack-1x fa-inverse dark-blue-text" })
                                ], -1 /* CACHED */)),
                                _cache[5] || (_cache[5] = _createTextVNode()),
                                _createElementVNode("h1", _hoisted_6, [
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.loginTitle(false)), 1 /* TEXT */),
                                    _cache[3] || (_cache[3] = _createTextVNode()),
                                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.loginTitle(true)), 1 /* TEXT */)
                                ])
                            ])
                        ]),
                        _cache[33] || (_cache[33] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_9, [
                            _createCommentVNode(" Show loading state while checking SSO "),
                            _cache[24] || (_cache[24] = _createTextVNode()),
                            (_ctx.isCheckingSso)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[6] || (_cache[6] = [
                                        _createElementVNode("i", { class: "fa fa-spinner fa-spin fa-2x" }, null, -1 /* CACHED */),
                                        _createTextVNode(),
                                        _createElementVNode("p", { class: "mt-2 text-muted" }, "Checking authentication options...", -1 /* CACHED */)
                                    ]))]))
                                : _createCommentVNode("v-if", true),
                            _cache[25] || (_cache[25] = _createTextVNode()),
                            _createCommentVNode(" Company Selection for SSO (only in dev/staging when no subdomain) "),
                            _cache[26] || (_cache[26] = _createTextVNode()),
                            (!_ctx.isCheckingSso && _ctx.showCompanySelection && _ctx.isDevelopmentOrStaging)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label" }, "Select Your Organization", -1 /* CACHED */)),
                                        _cache[10] || (_cache[10] = _createTextVNode()),
                                        _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedCompanyId) = $event)),
                                            class: "form-select"
                                        }, [
                                            _cache[7] || (_cache[7] = _createElementVNode("option", { value: null }, "-- Select Company --", -1 /* CACHED */)),
                                            _cache[8] || (_cache[8] = _createTextVNode()),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ssoCompanies, (company) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    key: company.companyId,
                                                    value: company.companyId
                                                }, _toDisplayString(company.companyName), 9 /* TEXT, PROPS */, _hoisted_13));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ], 512 /* NEED_PATCH */), [
                                            [_vModelSelect, _ctx.selectedCompanyId]
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true),
                            _cache[27] || (_cache[27] = _createTextVNode()),
                            _createCommentVNode(" SSO Login Button "),
                            _cache[28] || (_cache[28] = _createTextVNode()),
                            (!_ctx.isCheckingSso && _ctx.isSsoAvailable)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.ssoMessage), 1 /* TEXT */),
                                        _cache[12] || (_cache[12] = _createTextVNode()),
                                        _createVNode(_component_b_button, {
                                            type: "button",
                                            variant: "primary",
                                            onClick: _ctx.ssoLogin,
                                            class: "btn-lg",
                                            disabled: _ctx.showCompanySelection && !_ctx.selectedCompanyId
                                        }, {
                                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                                    _createElementVNode("i", { class: "fa fa-sign-in me-2" }, null, -1 /* CACHED */),
                                                    _createTextVNode("Login with SSO\r\n\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["onClick", "disabled"])
                                    ]),
                                    _cache[13] || (_cache[13] = _createTextVNode()),
                                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-center my-3" }, [
                                        _createElementVNode("hr", { class: "my-3" }),
                                        _createTextVNode(),
                                        _createElementVNode("small", { class: "text-muted" }, "Or use breakglass account")
                                    ], -1 /* CACHED */))
                                ]))
                                : _createCommentVNode("v-if", true),
                            _cache[29] || (_cache[29] = _createTextVNode()),
                            _createCommentVNode(" Standard Login Fields "),
                            _cache[30] || (_cache[30] = _createTextVNode()),
                            (!_ctx.isCheckingSso)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    _cache[15] || (_cache[15] = _createElementVNode("label", { class: "normal" }, "\r\n\t\t\t\t\t\t\t\tUsername\r\n\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                    _cache[16] || (_cache[16] = _createTextVNode()),
                                    _createVNode(_component_b_form_input, _mergeProps(_ctx.usernameVal, {
                                        type: "text",
                                        modelValue: _ctx.userName,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.userName) = $event)),
                                        modelModifiers: { trim: true },
                                        name: "username",
                                        class: { 'is-invalid': _ctx.errors && _ctx.errors.username },
                                        onKeyup: _withKeys(_ctx.attemptLogin, ["enter"]),
                                        autocomplete: "username",
                                        required: ""
                                    }), null, 16 /* FULL_PROPS */, ["modelValue", "class", "onKeyup"]),
                                    _cache[17] || (_cache[17] = _createTextVNode()),
                                    _withDirectives(_createElementVNode("div", _hoisted_18, "\r\n\t\t\t\t\t\t\t\t* Please enter your login\r\n\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                        [_vShow, _ctx.errors && _ctx.errors.username]
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true),
                            _cache[31] || (_cache[31] = _createTextVNode()),
                            (!_ctx.isCheckingSso)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _cache[19] || (_cache[19] = _createElementVNode("label", { class: "normal" }, "\r\n\t\t\t\t\t\t\t\tPassword\r\n\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                    _cache[20] || (_cache[20] = _createTextVNode()),
                                    _createVNode(_component_b_form_input, _mergeProps(_ctx.passwordVal, {
                                        type: _ctx.passwordInputType,
                                        modelValue: _ctx.password,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.password) = $event)),
                                        modelModifiers: { trim: true },
                                        name: "password",
                                        class: { 'is-invalid': _ctx.errors && _ctx.errors.password },
                                        onKeyup: _withKeys(_ctx.attemptLogin, ["enter"]),
                                        autocomplete: "current-password",
                                        required: ""
                                    }), null, 16 /* FULL_PROPS */, ["type", "modelValue", "class", "onKeyup"]),
                                    _cache[21] || (_cache[21] = _createTextVNode()),
                                    _withDirectives(_createVNode(_component_b_button, {
                                        type: "button",
                                        class: "password-visibility-toggle",
                                        onClick: _ctx.togglePasswordVisibility
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("i", {
                                                class: _normalizeClass(_ctx.passwordIconClass)
                                            }, null, 2 /* CLASS */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["onClick"]), [
                                        [_vShow, _ctx.errors && !_ctx.errors.password]
                                    ]),
                                    _cache[22] || (_cache[22] = _createTextVNode()),
                                    _withDirectives(_createElementVNode("div", _hoisted_20, "\r\n\t\t\t\t\t\t\t\t* Please enter your password\r\n\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                        [_vShow, _ctx.errors && _ctx.errors.password]
                                    ]),
                                    _cache[23] || (_cache[23] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_21, [
                                        _withDirectives(_createVNode(_component_router_link, {
                                            to: { name: 'forgotten-password' },
                                            class: "blue"
                                        }, {
                                            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tForgot your password?\r\n\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        }, 512 /* NEED_PATCH */), [
                                            [_vShow, !_ctx.isThirdPartyAuth]
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true),
                            _cache[32] || (_cache[32] = _createTextVNode()),
                            (!_ctx.isCheckingSso)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    _createVNode(_component_b_button, {
                                        type: "button",
                                        variant: "primary",
                                        onClick: _ctx.attemptLogin
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.statusText), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["onClick"])
                                ]))
                                : _createCommentVNode("v-if", true)
                        ])
                    ])
                ])
            ]))
            : _createCommentVNode("v-if", true)
    ]));
}
